/**
 * 版號(側欄左下角顯示)。格式 `V[A].[B].[C]`:
 *
 *   A  產品發布版本(1 位):開發階段 0;整個專案完成開發後定義為 1。
 *   B  階段發布版本(2 位):四個交付階段 8/30、9/30、12/31、最後 → 01、02、03、04。
 *   C  開發版號(3 位):每個 B 階段從 001 起算。**推上 SIT 才 +1**,關票／單一 commit 不加號。
 *
 * 8/30 階段用過 V0.01.001～013;9/30 階段從 V0.02.001 起(2026-09-14 重置,note 收錄前一階段)。
 * **B 看的是交付階段,不是日曆日期**:10 月推上 SIT 的仍是 9 月交付內容 → 仍是 02(2026-10-05 使用者更正)。
 *
 * 只改這一個字串,不要碰 package.json 的 version(`0.02.001` 不是合法 semver)。
 * 加號時同時更新下方 VERSION_LOG,讓「這個號碼對到哪次 SIT 部署」查得到。
 */
export const APP_VERSION = "V0.02.003";

/** 版號 ↔ 對應的 SIT 部署批次(新的放最上面)。B 換階段時 C 從 001 重數。 */
export const VERSION_LOG = [
  {
    version: "V0.02.003",
    date: "2026-10-05",
    note: [
      "分支 feat/notify-api(合入 PR #5／#6／#7)。(過程中曾誤標為 V0.03.001;9 月交付內容仍屬 02 階段,10/5 更正並合併為本號。)",
      "訊息查詢頁與小鈴鐺接 DcMessage(伺服器分頁、種類分頁筆數、關鍵字、標示已讀、鈴鐺未讀數雙向同步;舊靜音規則與暫停鈕移除);",
      "各類訊息設定接 DcNotificationRule(列表、分類計數、暫停／恢復、刪除＝軟刪為已作廢、系統事件、新增／編輯直接生效);",
      "軟體部署設備存檔接 AddDeployment／RemoveDeployment;",
      "營運資訊重新開放(只開 IP 與合約;專案／廠商隱藏);合約「全部服務等級」不送 serviceLevelId,SIT 列表不再為空;",
      "IP／合約批次匯入顯示並走模擬匯入(不寫資料);",
      "部署站隱藏讀寫 mock 的片段:審核歷程／送出審核／結案／撤回、各列表「顯示已廢除資料」、機房批次通知公告、/dev 與 /ref 頁;",
      "依 0923 稿調 IP／合約狀態 tag、維護週期 chip、工具列寬;",
      "10/6(尚未部署前併入):刪除彈窗與鎖定提示不再提審核、訊息前往連結對不到頁面就不顯示;對話框最高＝視窗高,只捲內容區;通知規則精靈的管理者改為必填。",
    ].join(" "),
  },
  {
    version: "V0.02.002",
    date: "2026-09-23",
    note: [
      "台企銀 POC 版(分支 sit-for-uat-poc;9/22 回報表 DCK-BUG-014～018):",
      "014 隱藏營運資訊選單與路由;015 機櫃列表已用U 改依機櫃內硬體加總;",
      "016 硬體／機櫃／軟體檢視欄位與編輯表單一致(對齊 Figma 0923);017 檢視字級與編輯相同;",
      "018 硬體匯入範本改為 swagger 現行 15 欄,四種範本測試直接比對 swagger。",
      "硬體作業系統／應用系統改軟體多選(存軟體 ID 陣列),韌體作業系統版本移到硬體序號後;",
      "硬體／軟體可指派 CPE(AssetVersion/SuggestCpe),顯示原廠最新可用版本。",
      "另含 9/16 起的共用層與守衛:顯示已廢除開關、分頁籤無障礙、已廢除載入失敗會講、",
      "IP 待確認確認鈕(票 32)、票 34 共用元件收口、寫入白名單補齊(票 40)、mock 對齊 swagger(票 39)、e2e 補齊(票 37/38)。",
    ].join(" "),
  },
  {
    version: "V0.02.001",
    date: "2026-09-14",
    note: [
      "9/30 階段起始(C 從 001 重數;推上 SIT 才加號)。",
      "最新:票 30 狀態下拉／已廢除 tag／已廢除列關鍵字比對收成共用元件(StatusFilterSelect、StatusCell retired、useArchivedRows keywords);八頁純重構,行為零改動。",
      "前一階段 V0.01.001～013:",
      "001 起始版號;UAT round 1 修復。",
      "002 八月唯讀驗收站(BUG-001～007、Rex 紅字);round 3 修復、看板 CVE 卡改綁受影響資產數、契約對齊、標準範本匯入、唯讀模式。",
      "003 9/10 驗收回饋:看板 CVE/KEV 卡排版、權限三態選中藍實底、匯入結果明細可捲;機房與機櫃標準範本匯入。",
      "004 票 24 派工月曆日期定時炸彈;票 25 IP/合約刪除彈窗文案對稿;票 16/18 補 IP/合約契約待確認。",
      "005 硬體/軟體無法刪除文案對回 WF_v3;票 13/08 狀態改標;CanDelete 缺口寫入票 16/18;figma 對稿規則更正。",
      "006 票 26 列表篩選條件跨頁保留。",
      "007 票 26 補齊九頁跨頁測試 + useStickyState key 守衛。",
      "008 票 29 角色/使用者列表狀態可篩選＋顯示已廢除資料。",
      "009 票 27 合約服務等級／維護週期改吃 Common 主檔;smoke 契約假設跟上;開票 30。",
      "010 9/14 SIT swagger 入庫(+32 支);票 16 轉 ready、18 拆出 33、開 31/32;wf-ui-adjustments 01/02 triage。",
      "011 票 16 IP 資訊切真後端 DcIpAddress。",
      "012 票 33 合約讀取側切真後端 DcContract;8/9 月畫面 e2e 補齊。",
      "013 票 30 共用層收成。",
    ].join(" "),
  },
];

/** 版號格式(測試與 CI 守著,避免手滑打成 V0.2.1 之類) */
export const VERSION_PATTERN = /^V\d\.\d{2}\.\d{3}$/;
